import { useRouteError } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { useT } from '../i18n/i18n';
import styles from './StatusPage.module.css';

/** Fallback for unexpected render errors in any route. */
export function RouteError() {
  const t = useT();
  const error = useRouteError();
  if (import.meta.env.DEV) console.error(error);
  return (
    <main className={styles.page}>
      <Logo />
      <div className={styles.art} aria-hidden="true">
        ⚠
      </div>
      <h1 className={styles.title}>{t('crash.title')}</h1>
      <p className={styles.text}>{t('crash.text')}</p>
      <button
        type="button"
        className={styles.link}
        style={{ border: 0, cursor: 'pointer' }}
        onClick={() => window.location.reload()}
      >
        {t('crash.reload')}
      </button>
    </main>
  );
}
